import Vue from 'vue';
import { ObserveVisibility } from 'vue-observe-visibility';
import ClickOutside from 'vue-click-outside';
import VueViewport from './plugins/vue-viewport';
import VueByl from './plugins/vue-byl';

Vue.use(VueByl);
Vue.use(VueViewport);
Vue.directive('observe-visibility', ObserveVisibility);
Vue.directive('click-outside', ClickOutside);

// Event bus for comunicate object asynchronously
const EventBus = new Vue();
Vue.prototype.$eventBus = EventBus;
window.Vue = Vue;

export { EventBus, Vue };
